const base = {
  url: 'api/'
}
export default base



// WEBPACK FOOTER //
// ./src/utils/base.js